import { MenuIcon, LogoutIcon } from 'components/icons';
import { Button } from 'components/ui';
import { useAuth } from 'features/auth';
import { ShopSwitcher } from './ShopSwitcher';

/** Sticky top bar: mobile menu toggle, vendor identity and logout. */
export function Topbar({ onOpenSidebar, profile }) {
  const { user, logout } = useAuth();
  const name = profile?.businessName || user?.fullName || 'Vendor';
  const initial = name.charAt(0).toUpperCase();

  return (
    <header className="sticky top-0 z-30 flex h-16 items-center gap-3 border-b border-surface-200 bg-white/80 px-4 backdrop-blur sm:px-6">
      <button
        type="button"
        onClick={onOpenSidebar}
        className="rounded-lg p-2 text-slate-500 transition hover:bg-surface-100 lg:hidden"
        aria-label="Open navigation"
      >
        <MenuIcon className="h-5 w-5" />
      </button>

      <ShopSwitcher />

      <div className="ml-auto flex items-center gap-3">
        <div className="hidden text-right sm:block">
          <p className="text-sm font-medium text-slate-800">{name}</p>
          {user?.phone && <p className="text-xs text-slate-500">+91 {user.phone}</p>}
        </div>
        <span className="flex h-9 w-9 items-center justify-center rounded-full bg-brand-100 text-sm font-semibold text-brand-700">
          {initial}
        </span>
        <Button
          variant="ghost"
          size="sm"
          onClick={logout}
          leftIcon={<LogoutIcon className="h-4 w-4" />}
        >
          <span className="hidden sm:inline">Logout</span>
        </Button>
      </div>
    </header>
  );
}

export default Topbar;
